import { RequestKind, boolean, string } from '@sb/library/base';
import { CashCategoryDisplayItem, CashCategoryInputItem, CashCategorySearchOptions, CashCategoryUpdateItem, CashDeleteOptions, DisplayItemCollection } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace CashCategoryRoutes {
    export const Add = ApiRoute.Define({
        URL: `cashcategories`,
        Kind: RequestKind.Post,
        BodyType: CashCategoryInputItem,
        ResultType: string
    });

    export const Delete = ApiRoute.Define({
        URL: (cashcategoryID: string) => `cashcategories/${cashcategoryID}`,
        BodyType: CashDeleteOptions,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const GetAll = ApiRoute.Define({
        URL: `cashcategories`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<CashCategoryDisplayItem>
    });

    export const Search = ApiRoute.Define({
        URL: `search/cashcategories`,
        Kind: RequestKind.Post,
        BodyType: CashCategorySearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<CashCategoryDisplayItem>
    });

    export const Get = ApiRoute.Define({
        URL: (cashcategoryID: string) => `cashcategories/${cashcategoryID}`,
        Kind: RequestKind.Get,
        ResultType: CashCategoryDisplayItem
    });

    export const Update = ApiRoute.Define({
        URL: (cashcategoryID: string) => `cashcategories/${cashcategoryID}`,
        Kind: RequestKind.Put,
        BodyType: CashCategoryUpdateItem,
        ResultType: boolean
    });
}
